<template>
  <v-row no-gutters class="mb-2">
    <span class="font-weight-bold">{{ title }}</span>:&nbsp; {{ val }}
  </v-row>
</template>

<script>
export default {
  props: ['title', 'val']
}
</script>
